import { useQuery } from '@tanstack/react-query';

import { listQueryOptions } from '@/lib/query-client';

import { exercisesService } from '../services';
import type { ClientExerciseListParams } from '../types';

import { clientExercisesKeys } from './useExercises';

export function useClientExercises(
  clientId: string | undefined,
  params: ClientExerciseListParams = {},
) {
  return useQuery({
    queryKey: clientExercisesKeys.operation('by-client', {
      clientId: clientId ?? '',
      ...params,
    }),
    queryFn: () => {
      if (!clientId) throw new Error('missing clientId');
      return exercisesService.listClientExercises(clientId, params);
    },
    enabled: Boolean(clientId),
    ...listQueryOptions,
  });
}
